import { Dialog, Portal, CloseButton, Button, Input, createListCollection, Select } from "@chakra-ui/react";

import React, { useEffect } from "react";
import { useState } from "react";
import { getEntityPropertiesKeys, getGeojsonPropertiesKey, saveToCache, showToast } from "../../../../../utilies/Utility";
import { updateDatasourceProperty, updateEntitiesProperty } from "../../../../../utilies/GeojsonUtility";
import Type from "../../../../../utilies/Types";
import { useAppStore } from "../../../../../context/store";
import { useMapObjects } from "../../../../../context/MapObjectsContext";
const LayersBultEditFeatureDialog = () => {
  // state
  const bultEditDialog = useAppStore((s) => s.bultEditDialog);
  const currentLayerForAttributeTable = useAppStore((s) => s.currentLayerForAttributeTable);
  const selectedFeatures = useAppStore((s) => s.selectedFeatures);
  const userData = useAppStore((s) => s.userData);

  const featureCached = useAppStore((s) => s.featureCached);

  // setters / refs
  const setBultEditDialog = useAppStore.getState().setBultEditDialog;

  const setQueryTable = useAppStore.getState().setQueryTable;
  const setFeatureCached = useAppStore.getState().setFeatureCached;
  const { mapObjects, setMapObjects, mapObjectsRef } = useMapObjects();

  const [newValue, setNewValue] = useState("");
  const [keys, setKeys] = useState([]);
  const [selectedKey, setSelectedKey] = useState(null);

  useEffect(() => {
    if (currentLayerForAttributeTable && bultEditDialog) {
      let temp = getGeojsonPropertiesKey(currentLayerForAttributeTable.geojson);
      setKeys(temp);
    } else if (bultEditDialog && !currentLayerForAttributeTable) {
      let temp = getEntityPropertiesKeys(selectedFeatures[0]);
      setKeys(temp);
    }
  }, [bultEditDialog]);

  const updateBultFeature = () => {
    if (!currentLayerForAttributeTable) {
      updateEntitiesProperty(selectedFeatures, selectedKey, newValue, setMapObjects, userData);
      setBultEditDialog(false);
      showToast("Updated", Type.NOTIFICATION.INFO);
    } else {
      setFeatureCached((prev) => {
        const updated = [...prev, newValue];
        saveToCache(Type.STORAGE.FEATURE_CACHED, updated);
        return updated;
      });
      updateDatasourceProperty(currentLayerForAttributeTable.dataSource, selectedKey, newValue, selectedFeatures);
      setBultEditDialog(false);
      setQueryTable((prev) => prev.map((item) => (selectedFeatures.includes(item.feature_id) ? { ...item, [selectedKey]: newValue } : item)));
    }
  };
  const keysCollection = React.useMemo(
    () =>
      createListCollection({
        items: keys,
        itemToString: (item) => item,
        itemToValue: (item) => item,
      }),
    [keys],
  );

  return (
    <Dialog.Root
      lazyMount
      open={bultEditDialog}
      onOpenChange={(e) => {
        setBultEditDialog(e.open);
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title> Edit Feature </Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Select.Root
                collection={keysCollection}
                size="sm"
                width="full"
                onSelect={(item) => {
                  setSelectedKey(item.value);
                }}
              >
                <Select.HiddenSelect />
                <Select.Label>Select Key</Select.Label>
                <Select.Control>
                  <Select.Trigger>
                    <Select.ValueText placeholder="Select Key" />
                  </Select.Trigger>
                  <Select.IndicatorGroup>
                    <Select.Indicator />
                  </Select.IndicatorGroup>
                </Select.Control>

                <Select.Positioner>
                  <Select.Content>
                    {keys.map((framework) => (
                      <Select.Item item={framework} key={framework}>
                        {framework}
                        <Select.ItemIndicator />
                      </Select.Item>
                    ))}
                  </Select.Content>
                </Select.Positioner>
              </Select.Root>
              <Input
                list="feature-cached"
                placeholder="Enter new value"
                value={newValue}
                mt={3}
                onChange={(v) => {
                  setNewValue(v.target.value);
                }}
              />
              <datalist id="feature-cached">
                {featureCached.map((item, i) => (
                  <option value={item} key={i} />
                ))}
              </datalist>
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline">Cancel</Button>
              </Dialog.ActionTrigger>
              <Button
                onClick={() => {
                  updateBultFeature();
                }}
              >
                Update
              </Button>
            </Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default LayersBultEditFeatureDialog;
